import { Center, Heading, Image, Spacer, StatusBar } from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';

import imageDone from '../../../../assets/images/done.png';
import ActionButton from '../../../shared/ActionButton';

function Returns({ onDone }) {
  return (
    <>
      <StatusBar backgroundColor="#ffffff" barStyle="dark-content" />
      <Spacer />
      <Center px="4">
        <Image source={imageDone} alt="NA" width="300" height="300" />
        <Heading textAlign="center">Le paiement est terminé !</Heading>
      </Center>
      <Spacer />
      <ActionButton onPress={onDone}>Retour</ActionButton>
    </>
  );
}

Returns.propTypes = {
  onDone: PropTypes.func.isRequired,
};

export default Returns;
